export const CREATABLE_ORGANISATION_TYPES = ["CRAFTSMAN", "CLIENT"] as const;
export type CreateableOrganisationType =
  (typeof CREATABLE_ORGANISATION_TYPES)[number];

export function isValidOrganisationType(
  type: string
): type is CreateableOrganisationType {
  return CREATABLE_ORGANISATION_TYPES.includes(type as any);
}
